import React from 'react';
import { CatHeadline } from '../components/component';

export default function Cntntadios() {
    return (
        <div>
            <CatHeadline name="adios" />
        </div>
    );
}